import React, { Component } from 'react'
import Slider from 'react-slick'
import './TeamRevenueMobile.sass'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import PropTypes from 'prop-types'

class SubTeamSelector extends Component {
  static propTypes = {
    subTeams: PropTypes.array,
    subTeamActive: PropTypes.bool,
    activeSubTeamNumber: PropTypes.number,
    teamName: PropTypes.string,
    setSubTeamActive: PropTypes.func,
    setSubTeamActiveTab: PropTypes.func,
    slidesToShow: PropTypes.number
  }

  render () {
    const settings = {
      speed: 300,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      variableWidth: false
    }

    return (
      <div className='dashboard-links'>
        <Slider {...settings}>
          <div className='subTeam-slide'>
            <button
              className={`dashboard-link ${
                !this.props.subTeamActive ? 'active' : ''
              }`}
              onClick={() => this.props.setSubTeamActive(false)}
            >
              {`Team ${this.props.teamName ?? ''}`}
            </button>
          </div>
          {this.props.subTeams.map((_, index) => (
            <div className='subTeam-slide' key={index}>
              <button
                className={`dashboard-link ${
                  this.props.subTeamActive &&
                  this.props.activeSubTeamNumber === index
                    ? 'active'
                    : ''
                }`}
                onClick={() => this.props.setSubTeamActiveTab(index)}
              >
                {`Subteam ${index + 1}`}
              </button>
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}

export default SubTeamSelector
